import { motion, AnimatePresence } from 'motion/react';
import { X } from '@phosphor-icons/react';
import LeadForm from './LeadForm';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export default function QuoteModal({ isOpen, onClose }: Props) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {/* Backdrop */}
          <motion.div
            key="backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.22 }}
            className="fixed inset-0 z-[100] bg-black/55 backdrop-blur-sm"
            onClick={onClose}
          />

          {/* Bottom sheet */}
          <motion.div
            key="sheet"
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', stiffness: 340, damping: 32 }}
            className="fixed bottom-0 left-0 right-0 z-[110] bg-white rounded-t-[28px] shadow-2xl"
            style={{ maxHeight: '92dvh', overflowY: 'auto' }}
          >
            {/* Drag handle */}
            <div className="flex justify-center pt-3 pb-1">
              <div className="w-10 h-1 rounded-full bg-gray-200" />
            </div>

            {/* Header */}
            <div className="flex items-start justify-between px-6 pt-3 pb-2">
              <div>
                <h2 className="font-display font-black text-[#071126] text-[18px] leading-tight">
                  Get a Free Quote
                </h2>
                <p className="text-gray-400 text-[12px] font-medium mt-0.5">
                  Our team replies within 1 hour
                </p>
              </div>
              <button
                onClick={onClose}
                className="p-2 hover:bg-gray-100 rounded-full transition-colors mt-0.5"
                aria-label="Close"
              >
                <X size={20} className="text-gray-400" />
              </button>
            </div>

            {/* Form */}
            <div className="px-6 pb-8 pt-2">
              <LeadForm variant="consultation" hideHeading />
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
